import { useState } from "react";
import { Modal, Button } from "antd";

const DeleteConfirmation = ({
  resource,
  onDeleteSuccess,
  deleteResource,
  notifyApi,
  icon = null,
  styles,
}) => {
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const resourceRef =
    resource?.name ||
    resource?.formName ||
    resource?.title ||
    resource?.description;

  const showModal = () => {
    setOpen(true);
  };

  const handleOk = async () => {
    setConfirmLoading(true);
    try {
      await deleteResource();
      notifyApi?.success({
        key: "condition-case-delete-error",
        message: "Delete Operation",
        description: `${resourceRef} deleted successfully`,
        duration: 2,
        showProgress: true,
        pauseOnHover: true,
      })
    } catch (err) {
      notifyApi?.error({
        key: "condition-case-delete-error",
        message: "Delete Operation",
        description: "Failed to delete resource. Please try again.",
        duration: 3,
        showProgress: true,
        pauseOnHover: true,
      });
      console.error("Delete error:", err);
    } finally {
      setConfirmLoading(false);
      setOpen(false);
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        type={styles ? null : "text"}
        danger
        onClick={showModal}
        style={{ padding: "4px 0" }}
        icon={icon}
        {...styles}
      >
        {styles ? null : "Delete"}
      </Button>

      <Modal
        title="Confirm Deletion"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        okText="Delete"
        okType="danger"
        cancelText="Cancel"
      >
        {resource ? (
          <>
            <p>
              Are you sure you want to delete{" "}
              <strong>
                <em>{resourceRef}</em>
              </strong>
              ?
            </p>
            <p style={{ color: "red" }}>This action cannot be reversed.</p>
          </>
        ) : (
          <>Are you sure you want to delete this item?</>
        )}
      </Modal>
    </>
  );
};

export default DeleteConfirmation;
